import React, { useEffect, useState } from "react";
import Layouts from "../../components/Layouts";
import { getDirectusClient } from "../../lib/directus";
import {
  createItem,
  readItems,
  readPermissions,
  updateItem,
  deleteItem,
} from "@directus/sdk";
import {
  Button,
  Col,
  DatePicker,
  InputNumber,
  Modal,
  Radio,
  Row,
  Select,
  Space,
  Table,
  Spin,
  message,
} from "antd";
import { Checkbox, Form, Input } from "antd";

import { readUsers } from "@directus/sdk";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import EditCircuitoModal from "./Components/EditCircuitoModal";
import validarpermiso from "../../lib/utils";

function Circuitos(props) {
  let { idruta, nombreruta } = useParams();
  const [formcreate] = Form.useForm();
  const [form] = Form.useForm();
  const [rutas, setRutas] = useState([]);
  const [openmodalcrear, setOpenmodalcrear] = useState(false);
  const [openmodalclientes, setOpenmodalclientes] = useState(false);
  const [vendedores, setVendedores] = useState([]);
  const [clientes, setClientes] = useState([]);
  const [clientescircuito, setClientescircuito] = useState([]);
  const [loading, setLoading] = useState(false);
  const [loadingClientes, setLoadingClientes] = useState(false);
  const [loadingTable, setLoadingTable] = useState(false);
  const [loadingVendedores, setLoadingVendedores] = useState(false);
  const [loadingGuardar, setLoadingGuardar] = useState(false);
  const [loadingClientesBtn, setLoadingClientesBtn] = useState(false);
  const userBodega = useSelector((state) => state.userdata.bodega?.id);
  const userRoleID = useSelector((state) => state.userdata.role.name);
  const [circuitoselect, setCircuitoselect] = useState({});
  const [openModalEditar, setOpenModalEditar] = useState(false);
  const [selectedCircuito, setSelectedCircuito] = useState(null);
  const [dias, setDias] = useState([]);
  const [fielderror, setFielderror] = useState("");
  const [error, setError] = useState(false);
  const [tipo, setTipo] = useState("");

  const userdata = useSelector((state) => state.userdata);
  const [hasPermissionError, setHasPermissionError] = useState(false);
  const permisos = useSelector((state) => state.permisos);

  const getUsers = async () => {
    setLoadingVendedores(true);
    const directus = await getDirectusClient();

    await directus
      .request(
        readUsers({
          fields: ["first_name", "id"],
          filter: {
            role: {
              name: "vendedor rutas",
            },
            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? { bodega: { id: { _eq: userBodega } } }
              : {}),
          },
         
        })
      )
      .then((result) => {
        console.log(result);
        setVendedores(result);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingVendedores(false);
      });
  };

  const getClientescircuito = async (idcircuito) => {
    setLoadingClientes(true);
    const directus = await getDirectusClient();

    await directus
      .request(
        readItems("circuitos_clientes", {
          fields: ["clientes_id.first_name", "clientes_id.id", "id"],
          filter: {
            circuitos_id: {
              id: {
                _eq: idcircuito,
              },
            },
          },
        })
      )
      .then((result) => {
        console.log(result);
        setClientescircuito(result);
        getClientes(result);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingClientes(false);
      });
  };

  const getCoordinadores = async () => {
    setLoadingVendedores(true);
    const directus = await getDirectusClient();

    await directus
      .request(
        readUsers({
          fields: ["first_name", "id"],
          filter: {
            role: {
              name: "vendedor ruta",
            },
          },
          ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
            ? { bodega: { id: { _eq: userBodega } } }
            : {}),
        })
      )
      .then((result) => {
        console.log(result);
        setVendedores(result);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingVendedores(false);
      });
  };

  const getDias = async () => {
    setLoading(true);
    const directus = await getDirectusClient();
    await directus
      .request(readItems("dias", {}))
      .then((dias) => {
        console.log(dias);
        setDias(dias);
      })
      .catch((err) => console.log(dias))
      .finally(() => {
        setLoading(false);
      });
  };

  const getRutas = async () => {
    if (!validarpermiso("circuitos", "read", permisos)) {
      setHasPermissionError(true);
      return;
    }

    setLoadingTable(true);
    try {
      const directus = await getDirectusClient();
      const rutasres = await directus.request(
        readItems("circuitos", {
          fields: ["nombre", "descripcion", "id"],
          filter: {
            ruta: {
              id: idruta,
            },
          },
        })
      );
      setRutas(rutasres);
      setHasPermissionError(false);
    } catch (error) {
      console.error("Error fetching circuits:", error);
      if (
        error.response?.status === 403 ||
        error.message?.includes("permission")
      ) {
        setHasPermissionError(true);
      }
    } finally {
      setLoadingTable(false);
    }
  };

  const getRutaDetails = async () => {
    try {
      const directus = await getDirectusClient();
      const rutaDetails = await directus.request(
        readItems("rutas", {
          fields: ["id", "nombre", "bodega.id"],
          filter: {
            id: {
              _eq: idruta
            }
          }
        })
      );
      if (rutaDetails && rutaDetails.length > 0) {
        return rutaDetails[0];
      }
      return null;
    } catch (error) {
      console.error("Error fetching ruta details:", error);
      return null;
    }
  };

  const handleOk = () => {
    setOpenmodalcrear(false);
  };
  const handleCancel = () => {
    setOpenmodalcrear(false);
  };

  useEffect(() => {
    getRutas();
    getDias();
    getUsers();
    getRutaDetails();
    if (userdata) {
      console.log(userdata);
    }
  }, []);
  const getCircuitoDetails = async (circuitoId) => {
    if (!validarpermiso("circuitos", "read", permisos)) {
      message.error("No tiene permisos para ver detalles del circuito");
      return;
    }
    setLoading(true);
    const directus = await getDirectusClient();

    try {
      const result = await directus.request(
        readItems("circuitos", {
          fields: [
            "id",
            "nombre",
            "descripcion",
            "vendedor",
            "tipo",
            "tiempo",
            "dia_tiempo",
            "fecha_inicio",
            "dias.id",
            "dias.dias_id.id",
            "dias.dias_id.nombre",
          ],
          filter: {
            id: {
              _eq: circuitoId,
            },
          },
        })
      );

      if (result && result.length > 0) {
        setSelectedCircuito(result[0]);
        setOpenModalEditar(true);
      }
    } catch (err) {
      console.error("Error fetching circuit details:", err);
    } finally {
      setLoading(false);
    }
  };

  const handleDelete = async (record) => {
    if (!validarpermiso("circuitos", "delete", permisos)) {
      message.error("No tiene permisos para eliminar circuitos");
      return;
    }

    Modal.confirm({
      title: "¿Está seguro de eliminar este circuito?",
      content: `Se eliminará el circuito "${record.nombre}"`,
      okText: "Sí, eliminar",
      okType: "danger",
      cancelText: "No, cancelar",
      async onOk() {
        try {
          setLoadingTable(true);
          const directus = await getDirectusClient();
          await directus.request(deleteItem("circuitos", record.id));
          message.success("Circuito eliminado correctamente");
          getRutas(); // Refresh the data
        } catch (error) {
          console.error("Error deleting circuit:", error);
          message.error("Error al eliminar el circuito");
        } finally {
          setLoadingTable(false);
        }
      },
    });
  };

  const columns = [
    {
      title: "Nombre",
      dataIndex: "nombre",
    },
    {
      title: "Descripcion",
      dataIndex: "descripcion",
    },
    {
      title: "Acciones",
      key: "Acciones",
      render: (_, record) => (
        <Space size="middle">
          {validarpermiso("circuitos", "read", permisos) && (
            <Button
              loading={loadingClientesBtn}
              onClick={async () => {
                setLoadingClientesBtn(true);
                setCircuitoselect(record);
                await getClientescircuito(record.id);
                setLoadingClientesBtn(false);
              }}
            >
              Clientes
            </Button>
          )}
          {validarpermiso("circuitos", "update", permisos) && (
            <Button onClick={() => getCircuitoDetails(record.id)}>
              Editar
            </Button>
          )}
          {validarpermiso("circuitos", "delete", permisos) && (
            <Button type="link" danger onClick={() => handleDelete(record)}>
              Eliminar
            </Button>
          )}
        </Space>
      ),
    },
  ];

  const getClientes = async (clientesexistentes) => {
    setLoadingClientes(true);
    var clientesexistearray = [];

    clientesexistentes.map((cliente) => {
      clientesexistearray.push(cliente.clientes_id?.id);
    });

    const directus = getDirectusClient();
    await directus
      .request(
        readUsers({
          fields: ["first_name", "id"],
          filter: {
            role: {
              name: "clientes",
            },

            ...(userRoleID !== "adminapp" && userRoleID !== "Administrator"
              ? {
                  bodega: { id: { _eq: userBodega } },
                }
              : {}),
          },
        })
      )
      .then((result) => {
        console.log(result);

        clientesexistearray.map((cliente) => {
          result = result.filter((item) => item.id != cliente);
        });
        console.log("dataresult");
        console.log(clientesexistearray);
        console.log(result);

        setClientes(result);
        setOpenmodalclientes(true);
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setLoadingClientes(false);
      });
  };

  const onFinish = async (r) => {
    if (!validarpermiso("circuitos", "create", permisos)) {
      message.error("No tiene permisos para crear circuitos");
      return;
    }
    setLoadingGuardar(true);

    if (r.tipo == "dias") {
      var created = [];
      r.dias.map((dia) => {
        created.push({
          circuitos_id: "+",
          dias_id: {
            id: dia,
          },
        });
      });
    } else if (r.tipo == "tiempo") {
      console.log("tiempo");
    }

    // Obtener la información de la ruta para conseguir el id de la bodega
    const rutaDetails = await getRutaDetails();
    const bodegaId = rutaDetails?.bodega?.id;

    const directus = await getDirectusClient();
    await directus
      .request(
        createItem("circuitos", {
          dias: {
            create: created,
            update: [],
            delete: [],
          },
          nombre: r.nombre,
          descripcion: r.descripcion,
          tipo: r.tipo,
          tiempo: r.tiempo,
          dia_tiempo: r.dia,
          fecha_inicio: r.fecha_inicio,
          vendedor: r.vendedor,
          ruta: idruta,
          bodega: bodegaId // Agregar el id de la bodega
        })
      )
      .then((res) => {
        console.log(res);
        getRutas();
        handleCancel();
      })
      .catch((er) => {
        console.log(er.errors[0].extensions.field);
        setFielderror(er.errors[0].extensions.field);
        setError(true);
      })
      .finally(() => {
        setLoadingGuardar(false);
      });
  };

  const guardarvendedorenruta = async (r) => {
    setLoadingGuardar(true);
    const directus = await getDirectusClient();
    await directus
      .request(
        updateItem("rutas", props.data.id, {
          vendedores: {
            create: [
              {
                rutas_id: "+",
                directus_users_id: {
                  id: r.coordinador,
                },
              },
            ],
            update: [],
            delete: [
              props.data.coordinador ? props.data.coordinador[0].id : null,
            ],
          },

          nombre: r.nombre,

          descripcion: r.descripcion,
        })
      )
      .then((res) => {
        console.log(res);
        props.handleCanceleditar();
        setError("");
      })
      .catch((er) => {
        console.log(er.errors[0].extensions.field);
        setFielderror(er.errors[0].extensions.field);
        setError(true);
      })
      .finally(() => {
        setLoadingGuardar(false);
      });
  };

  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };

  const handleSearch = async (value) => {
    setLoadingClientes(true);
    console.log("buscando");

    var clientesexistearray = [];

    clientescircuito.map((cliente) => {
      clientesexistearray.push(cliente.clientes_id.id);
    });

    const directus = await getDirectusClient();
    await directus
      .request(
        readUsers({
          search: value,
          fields: "*.*",
          limit: -1,
          filter: {
            role: {
              name: {
                _eq: "clientes",
              },
            },
          },
        })
      )
      .then((response) => {
        clientesexistearray.map((cliente) => {
          response = response.filter((item) => item.id != cliente);
        });
        console.log(response);
        setClientes(response);
      })
      .finally(() => {
        setLoadingClientes(false);
      });
  };

  const anadirclientes = async (v) => {
    setLoadingGuardar(true);
    console.log(v.clientes.length);
    const directus = await getDirectusClient();
    var creates = [];
    v.clientes.map((cliente) => {
      creates.push({
        circuitos_id: circuitoselect.id,
        clientes_id: {
          id: cliente,
        },
      });
    });

    await directus
      .request(
        updateItem("circuitos", circuitoselect.id, {
          clientes: {
            create: creates,
            update: [],
            delete: [],
          },
        })
      )
      .then((response) => {
        console.log(response);
        getClientescircuito(circuitoselect.id);
        form.resetFields();
      })
      .finally(() => {
        setLoadingGuardar(false);
      });
  };
  const handleCircuitoUpdated = () => {
    getRutas();
    setOpenModalEditar(false);
  };
  return (
    <Layouts>
      {!hasPermissionError ? (
        <>
          <h3 style={{ color: "#555" }}>Circuitos de ruta: {nombreruta}</h3>
          {validarpermiso("circuitos", "create", permisos) && (
            <Button
              onClick={() => setOpenmodalcrear(true)}
              disabled={hasPermissionError}
            >
              Crear Circuito
            </Button>
          )}
          <Table
            loading={loadingTable}
            dataSource={rutas}
            columns={columns.map((col) => {
              if (col.key === "Acciones") {
                return {
                  ...col,
                  render: (_, record) => (
                    <Space size="middle">
                      {validarpermiso("circuitos", "read", permisos) && (
                        <Button
                          loading={loadingClientesBtn}
                          onClick={async () => {
                            setLoadingClientesBtn(true);
                            setCircuitoselect(record);
                            await getClientescircuito(record.id);
                            setLoadingClientesBtn(false);
                          }}
                        >
                          Clientes
                        </Button>
                      )}
                      {validarpermiso("circuitos", "update", permisos) && (
                        <Button onClick={() => getCircuitoDetails(record.id)}>
                          Editar
                        </Button>
                      )}
                      {validarpermiso("circuitos", "delete", permisos) && (
                        <Button
                          type="link"
                          danger
                          onClick={() => handleDelete(record)}
                        >
                          Eliminar
                        </Button>
                      )}
                    </Space>
                  ),
                };
              }
              return col;
            })}
          />
        </>
      ) : (
        <h3>No tiene permisos para ver circuitos</h3>
      )}

      <Modal
        title={
          <p>
            Crear Ciruito para Ruta:{" "}
            <span style={{ color: "green" }}>{nombreruta}</span>
          </p>
        }
        open={openmodalcrear && validarpermiso("circuitos", "create", permisos)}
        onOk={false}
        onCancel={handleCancel}
        footer={null}
      >
        {error ? (
          <p style={{ color: "red" }}>
            El campo {fielderror} ya existe en el sistema{" "}
          </p>
        ) : null}

        <Form
          name="basic"
          labelCol={{
            span: 8,
          }}
          wrapperCol={{
            span: 16,
          }}
          style={{
            maxWidth: 600,
          }}
          initialValues={{
            remember: true,
          }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
        >
          <Form.Item
            label="Vendedor"
            name="vendedor"
            rules={[
              {
                required: true,
                message: "ingresar descripcion",
              },
            ]}
          >
            <Select loading={loadingVendedores}>
              {vendedores.map((vendedor) => {
                return (
                  <Select.Option value={vendedor.id}>
                    {vendedor.first_name}
                  </Select.Option>
                );
              })}
            </Select>
          </Form.Item>
          <Form.Item
            label="Nombre"
            name="nombre"
            rules={[
              {
                required: true,
                message: "ingresar nombre",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Descripcion"
            name="descripcion"
            rules={[
              {
                required: true,
                message: "ingresar descripcion",
              },
            ]}
          >
            <Input />
          </Form.Item>
          <Form.Item
            label="Tipo de visitas"
            name="tipo"
            rules={[
              {
                required: true,
                message: "ingresar descripcion",
              },
            ]}
          >
            <Select
              onChange={(e) => {
                setTipo(e);
              }}
            >
              <Select.Option value="dias">Por dias</Select.Option>
              <Select.Option value="tiempo">por Tiempo</Select.Option>
            </Select>
          </Form.Item>
          {tipo == "dias" ? (
            <Form.Item
              rules={[
                {
                  required: true,
                  message: "no puede estar vacio ",
                },
              ]}
              name="dias"
              label="Dias de visitas"
            >
              <Checkbox.Group>
                <Row>
                  {dias.map((dia) => {
                    return (
                      <Col span={8}>
                        <Checkbox value={dia.id} style={{ lineHeight: "32px" }}>
                          {dia.dia}
                        </Checkbox>
                      </Col>
                    );
                  })}
                </Row>
              </Checkbox.Group>
            </Form.Item>
          ) : null}
          {tipo == "tiempo" ? (
            <>
              <Form.Item
                label="Fecha de inicio"
                name="fecha_inicio"
                rules={[
                  {
                    required: true,

                    message: "no puede estar vacio ",
                  },
                  {
                    type: "date",
                    message: "Debe ser una fecha ",
                  },
                ]}
              >
                <DatePicker />
              </Form.Item>
              <Form.Item
                label="Tiempo"
                name="tiempo"
                rules={[
                  {
                    required: true,

                    message: "no puede estar vacio ",
                  },
                  {
                    type: "integer",
                    message: "Debe ser numericoo ",
                  },
                ]}
              >
                <InputNumber min={1} max={365} />
              </Form.Item>
              <Form.Item
                rules={[
                  {
                    required: true,
                    message: "no puede estar vacio ",
                  },
                ]}
                name="dia"
                label="El siguiente"
              >
                <Radio.Group>
                  <Row>
                    {dias.map((dia) => {
                      return (
                        <Col span={8}>
                          <Radio value={dia.id} style={{ lineHeight: "32px" }}>
                            {dia.dia}
                          </Radio>
                        </Col>
                      );
                    })}
                  </Row>
                </Radio.Group>
              </Form.Item>
            </>
          ) : null}
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button loading={loadingGuardar} type="primary" htmlType="submit">
              Guardar
            </Button>
          </Form.Item>
        </Form>
      </Modal>
      <Modal
        title={<p>Añadir clientes</p>}
        open={
          openmodalclientes && validarpermiso("circuitos", "update", permisos)
        }
        onOk={false}
        onCancel={() => setOpenmodalclientes(false)}
        footer={null}
      >
        {circuitoselect.nombre}
        <Form onFinish={anadirclientes} form={form}>
          <Form.Item name="clientes" label="Seleccionar clientes">
            <Select
              mode="multiple"
              name={"clientes"}
              showSearch={true}
              filterOption={false}
              onSearch={handleSearch}
              style={{ width: "100%" }}
              placeholder="Seleccionar clientes"
              loading={loadingClientes}
            >
              {clientes?.map((cliente) => (
                <Select.Option key={cliente.id} value={cliente.id}>
                  {cliente.first_name}
                </Select.Option>
              ))}
            </Select>
          </Form.Item>
          <Form.Item
            wrapperCol={{
              offset: 8,
              span: 16,
            }}
          >
            <Button loading={loadingGuardar} type="primary" htmlType="submit">
              asignar
            </Button>
          </Form.Item>
        </Form>
        <Table loading={loadingClientes} dataSource={clientescircuito}>
          <Table.Column
            title="Nombre"
            dataIndex="first_name"
            render={(_, record) => {
              return record.clientes_id?.first_name;
            }}
          />
          <Table.Column
            title="Apellido"
            dataIndex="last_name"
            render={(_, record) => {
              return record.clientes_id?.last_name;
            }}
          />
          <Table.Column
            title="Acciones"
            key="acciones"
            render={(_, record) => (
              <Space size="middle">
                <Button
                  type="link"
                  danger
                  onClick={async () => {
                    setLoadingGuardar(true);
                    const directus = await getDirectusClient();

                    await directus
                      .request(
                        updateItem("circuitos", circuitoselect.id, {
                          clientes: {
                            create: [],
                            update: [],
                            delete: [record.id],
                          },
                        })
                      )
                      .then((response) => {
                        console.log(response);
                        getClientescircuito(circuitoselect.id);
                        form.resetFields();
                      })
                      .finally(() => {
                        setLoadingGuardar(false);
                      });
                  }}
                >
                  eliminar
                </Button>
              </Space>
            )}
          />
        </Table>
      </Modal>
      <EditCircuitoModal
        visible={
          openModalEditar && validarpermiso("circuitos", "update", permisos)
        }
        circuito={selectedCircuito}
        onCancel={() => setOpenModalEditar(false)}
        onSuccess={handleCircuitoUpdated}
      />
    </Layouts>
  );
}

export default Circuitos;
